const size = {
  container_width_lg: '75%',
  container_width_md: '86%',
  container_width_sm: '90%',
}

export default size
